module.exports = __webpack_public_path__ + "img/blog-5-3.baf94f3f.webp";